import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Config/store.ts";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { createTheme } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
const rootElement = document.getElementById("root");

const theme = createTheme({
  typography: {
    fontFamily: "'Averta', sans-serif !important",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Averta';
          src: url('/fonts/Averta Standard Font/AvertaStd-Black.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
        }
        body {
          font-family: 'Averta', sans-serif !important;
        }
       input::placeholder {
          color: green !important;
        
        }
      `,
    },
  },
});

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Provider store={store}>
            <ToastContainer/>
            <App />
          </Provider>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  console.error("Root element not found. Unable to render the application.");
}
